import { render } from "./PostView.vue?vue&type=template&id=579d755b&scoped=true&ts=true"
import script from "./PostView.vue?vue&type=script&lang=ts"
export * from "./PostView.vue?vue&type=script&lang=ts"

import "./PostView.vue?vue&type=style&index=0&id=579d755b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579d755b"]])

export default __exports__